<template lang="html">
  <form id="formContacto" @submit.prevent="validateBeforeSubmit">
    <h2 class="title">{{ $t("formulario.title") }}</h2>

    <p>{{ $t("formulario.description") }}</p>

    <div class="contenedor-input">
      <label for="">{{ $t("formulario.empresaLabel") }}</label>
      <input type="text" class="input-text" v-validate="'required'" name="empresa"
        :placeholder="$t('formulario.empresa') + '*'" />
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{
        errors.first("nombre")
      }}</span>
    </div>

    <div class="contenedor-input">
      <label for="">{{ $t("formulario.nombre_apellidoslabel") }}</label>
      <input type="text" class="input-text" v-validate="'required'" name="nombre"
        :placeholder="$t('formulario.nombre_apellidos') + '*'" />
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{
        errors.first("nombre")
      }}</span>
    </div>

    <div class="contenedor-input">
      <label for="">{{ $t("formulario.emailLabel") }}</label>
      <input type="text" class="input-text" v-validate="'required|email'" name="email"
        :placeholder="$t('formulario.email') + '*'" />
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{
        errors.first("email")
      }}</span>
    </div>

    <div class="contenedor-input">
      <label for="">{{ $t("formulario.tfno") }}</label>
      <input type="text" class="input-text" v-validate="'length:9'" name="telefono"
        :placeholder="$t('formulario.telefono')" />
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{
        errors.first("telefono")
      }}</span>
    </div>

    <div class="contenedor-input" v-if="lang != 'it'">
      <label for="producto">{{ $t("formulario.producto") }}</label>
      <select name="producto" v-validate="'required'">
        <option value="">{{
          $t("formulario.optionProduct.seleccionar")
        }}</option>
        <option value="Iformalia (Módulo Core)">{{
          $t("formulario.optionProduct.iformalia")
        }}</option>
        <option value="Kit Digital">{{
          $t("formulario.optionProduct.kitDigital")
        }}</option>
        <option value="Gestor de Aulas Virtuales">{{
          $t("formulario.optionProduct.gestor_aulas")
        }}</option>
        <option value="Firm@ digital para Formación Presencial">{{
          $t("formulario.optionProduct.firma_digital")
        }}</option>
        <option value="Detección de Necesidades de Formación">{{
          $t("formulario.optionProduct.necesidades_formacion")
        }}</option>
        <option value="Plataforma eLearning (LMS)">{{
          $t("formulario.optionProduct.plataforma_elearnign")
        }}</option>
        <option value="Portal del Alumno para empleado">{{
          $t("formulario.optionProduct.portal_alumno")
        }}</option>
        <option value="Reporting y KPIS">{{
          $t("formulario.optionProduct.reporting_kpis")
        }}</option>
        <option value="CRM Comercial">{{
          $t("formulario.optionProduct.crm_comercial")
        }}</option>
      </select>


      <span class="dropdown"></span>
    </div>


    <div class="contenedor-input">
      <label for="">{{ $t("formulario.mensajeLabel") }}</label>
      <textarea :placeholder="$t('formulario.mensaje') + '*'" name="mensaje" v-validate="'required'"></textarea>
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{
        errors.first("mensaje")
      }}</span>
    </div>

    <div class="contenedor-check">
      <input type="checkbox" id="politica-contacto" v-validate="'required'" name="politica" />
      <label for="politica-contacto">{{ $t("banner_newsletter.HeLeidoYacepto")
        }}<router-link target="_blank" :to="$t('enlaces.politica_privacidad')">{{ $t("banner_newsletter.politica") }}
        </router-link></label>
      <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{
        errors.first("politica")
      }}</span>
    </div>

    <input type="hidden" name="from" value="iformalia" />

    <button v-if="!sended" class="btn-rounded-blue" id="btnContacto" @click="trackingListener">{{
      $t("formulario.enviar") }}</button>

    <h4 class="gracias animated fadeInUp" v-if="sended">{{ $t("formulario.gracias") }}</h4>
  </form>
</template>

<script lang="js">


import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'formulario',
  props: [],
  mounted() {

  },
  data() {
    return {
      clicked: false,
      sended: false
    }
  },
  methods: {
    ...mapActions(['sendContacto', 'setLoading']),
    validateBeforeSubmit: function () {

      this.clicked = true;
      this.$validator.validateAll().then(canSend => {

        if (canSend) {
          this.setLoading(true);
          this.sendContacto($("#formContacto").serialize())
            .then(result => {
              this.setLoading(false);
              this.sended = true;
              $("#formContacto")[0].reset();

              this.gtag_report_conversion();
              this.gtag_click_category()
            });
        }
      });
    },
    gtag_report_conversion(url) {
      var callback = () => {
        if (typeof (url) != 'undefined') {
          window.location = url;
        }
      };

      gtag('event', 'conversion', {
        'send_to': 'AW-663879014/wNTACJuR_88DEOb6x7wC',
        'event_callback': callback
      });

      return false;
    },
    gtag_click_category() {
      gtag('event', 'clic_boton', {
        'event_category': 'Interacción',
        'event_label': 'Botón de prueba',
        'value': 1
      });

      return false;
    },
    trackingListener() {
      const capterra_vkey = 'b7a1b3a3f654100d8113ab4b2df2fa5d';
      const capterra_vid = '2311588';
      const ct = document.createElement('img');
      ct.src =
        'https://ct.capterra.com/capterra_tracker.gif?vid=' +
        capterra_vid +
        '&vkey=' +
        capterra_vkey;
      document.body.appendChild(ct);
    },
  },
  computed: {
    ...mapGetters({
      lang: 'getLanguage'
    })
  }
}
</script>

<style scoped>
form {
  position: relative;
  padding-bottom: 100px;
  margin-bottom: 100px;
}

h2 {
  text-align: left;
  color: #41566d;
  margin-bottom: 20px;
}

p {
  color: #41566d;
  text-align: left;
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 30px;
}

.contenedor-input {
  width: 100%;
  padding-bottom: 20px;
  position: relative;
}

.contenedor-input label {
  width: 100%;
  font-family: "Ubuntu Mono";
  font-size: 18px;
  line-height: 28px;
  color: #3374b0;
  display: inline-block;
  text-align: left;
  margin-bottom: 5px;
}

.contenedor-input input,
.contenedor-input textarea,
.contenedor-input select {
  width: 100%;
  text-align: left;
  padding: 0 15px;
  color: #3374b0;
  height: 40px;
  line-height: 40px;
  border: 1px solid #3374b0;
  outline: none;
}

.contenedor-input textarea {
  height: 160px;
  resize: none;
}

.contenedor-input input::placeholder,
.contenedor-input textarea::placeholder {
  color: #3374b0;
}

.dropdown {
  width: 40px;
  height: 40px;
  background: url(/static/img/next-blue.svg) center/13px no-repeat;
  position: absolute;
  right: 0;
  bottom: 20px;
  transform: rotate(90deg);
}

.btn-rounded-blue {
  min-width: 150px;
  outline: none;
  margin-top: 20px;
}

.contenedor-check {
  padding-bottom: 15px;
}

.contenedor-check label {
  color: #3374b0;
}

.contenedor-check label::before {
  border-color: #3374b0;
}

.contenedor-check input:checked+label::before {
  color: #3374b0;
}

.error {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  color: #df1517;
  font-size: 12px;
  text-align: left;
}

.gracias {
  text-align: center;
  width: 100%;
  font-family: "Ubuntu Mono";
  font-size: 24px;
  color: #3374b0;
  text-transform: uppercase;
  opacity: 0;
  pointer-events: none;
  margin-top: 20px;
  line-height: 1.1em;
}

.gracias.active {
  opacity: 1;
}

@media screen and (max-width: 600px) {
  p {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 20px;
  }

  .contenedor-input label {
    font-size: 14px;
    line-height: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/view-parts/contacto/formulario.vue